import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Lock, HelpCircle } from "lucide-react";
import Toggle from "react-toggle";
import { PageContainer } from "../../../sharedStyles";

export const LabelNote = styled.span`
  color: #888;
  font-weight: normal;
  font-size: 16px;
`;

const SalaryInputs = styled.div`
  display: flex;
  justify-content: space-between;
  & input {
    width: 100%;
  }
  & select {
    width: 90px;
  }

  gap: 10px;
`;

const CheckWrap = styled.div`
  display: flex;
  flex-direction: row;
`;

const ToggleContainer = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: left;

  & div {
    margin: 0 4px;
  }
`;

const Hyphen = styled.div`
  padding-top: 5px;
`;

const renderCandidate = () => {
  return (
    <>
      <form>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <br />
            <p>
              <strong>Note:</strong> These details will be visible to other
              agencies on the platform when sharing is activated. Please ensure
              you check all fields (particularly the Description/Profile) for
              any identifiable information.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            {" "}
            <div className="space-y-2">
              <Label htmlFor="formFamilyName">Family name*</Label>{" "}
              <LabelNote>
                <Lock className="inline h-4 w-4" />
              </LabelNote>{" "}
              <Input
                type="text"
                name="lastName"
                id="formFamilyName"
                required
              />
            </div>
          </div>
          <div>
            {" "}
            <div className="space-y-2">
              <Label htmlFor="firstName">First name*</Label>
              <LabelNote>
                <Lock className="inline h-4 w-4" />
              </LabelNote>{" "}
              <Input
                type="text"
                name="firstName"
                id="firstName"
                required
              />
            </div>
          </div>
        </div>
        <br />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <div className="space-y-2">
                  <Label htmlFor="formLocation">Location*</Label>
                  <select
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    name="localityId"
                    id="formLocation"
                  >
                    <option></option>
                  </select>
                </div>
              </div>
              <div>
                <div className="space-y-2">
                  <Label htmlFor="formType">Type</Label>
                  <select
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    name="workType"
                    id="formType"
                  >
                    <option value=""></option>
                    <option value="PERMANENT">PERMANENT</option>
                    <option value="TEMP">CONTRACT/TEMP</option>
                    <option value="ANY">ANY</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="space-y-2">
              <Label htmlFor="salaryMin">Salary range (min. $40,000)*</Label>
              <SalaryInputs>
                <div>
                  <Input
                    type="number"
                    name="salaryMin"
                    id="salaryMin"
                    placeholder="Min."
                    required
                  />{" "}
                </div>
                <Hyphen> - </Hyphen>
                <div>
                  <Input
                    type="number"
                    name="salaryMax"
                    placeholder="Max."
                    required
                  />{" "}
                </div>
                <div>
                  <select
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    name="currency"
                  >
                    <option value="AUD">AUD</option>
                    <option value="NZD">NZD</option>
                  </select>
                </div>
              </SalaryInputs>
            </div>
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 gap-4">
          <div>
            <div className="space-y-2">
              <Label htmlFor="formRole">Description/Profile*</Label><br/>
              <textarea
                name="description"
                id="formRole"
                required />
            </div>
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="space-y-2">
              <Label htmlFor="formIndustry">Industry*</Label>
              <select
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                name="industry"
                id="formIndustry"
              >
                <option></option>
              </select>
            </div>
          </div>
          <div>
            <div className="space-y-2">
              <Label htmlFor="formRoleExperience">Years experience*</Label>
              <Input
                type="number"
                name="yearsOfExperience"
                id="formRoleExperience"
                required
              />
            </div>
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 gap-4">
          <div>
            <div className="space-y-2">
              <Label htmlFor="formRoleIdealJobTitle">Ideal job titles*</Label>
              <Input
                type="text"
                name="idealJobTitles"
                id="formRoleIdealJobTitle"
                required
              />
            </div>
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 gap-4">
          <div>
            <CheckWrap>
              <div className="flex items-center space-x-2">
                <Checkbox id="interviewed" name="interviewed" />
                <label htmlFor="interviewed">I have received permission from the candidate to be represented on Role Relay in the last 3 months</label>
              </div>{" "}
              &nbsp;{" "}
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <HelpCircle className="inline h-4 w-4 cursor-help" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Role Relay's terms dictate that:</p>
                    <ul>
                      <li>
                        Only candidates that you have engaged with in the last
                        3 months can be represented on the platform.
                      </li>
                    </ul>
                    <ul>
                      <li>
                        You must have written permission from the candidate to
                        represent them on the platform.
                      </li>
                    </ul>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </CheckWrap>
          </div>
        </div>
        <hr />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Sharing</Label>{" "}
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <HelpCircle className="inline h-4 w-4 cursor-help" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>
                    <strong>Shared for Collaboration</strong> will push this
                    candidate to the Role Relay Network based on your{" "}
                    <strong>Audience</strong> selection. Candidates you do not
                    wish to share with the network can be set to{" "}
                    <strong>Draft</strong>.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <ToggleContainer>
              <span>Draft</span>
              <Toggle
                name="shared"
                icons={false}
              />{" "}
              <span>Shared for collaboration</span>
            </ToggleContainer>
          </div>
          <div>
            <div className="space-y-2">
              <Label htmlFor="formAudience">Audience</Label>{" "}
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <HelpCircle className="inline h-4 w-4 cursor-help" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>
                      Select which audience you would like to share the
                      Candidate with.
                    </p>
                    <ul>
                      <li>
                        <strong>Private</strong> - only flagged for Role Relay
                        automatic matching. You will receive notifications of
                        opportunities Role Relay detects for this candidate,
                        but their anonymous details will not be searchable for
                        other agencies on the Public or Partner Candidate
                        Boards.
                      </li>
                      <li>
                        <strong>Partners Only</strong> - flagged for Role
                        Relay automatic matching, and listed on the Partner
                        Candidate Board. The candidate's anonymous details
                        will not be searchable on the Public Candidate Board.
                      </li>
                      <li>
                        <strong>Public</strong> - flagged for matching, and
                        listed on the Partner and Public Candidate Board.
                      </li>
                    </ul>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              <select
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                name="audience"
                id="formAudience"
              >
                <option value=""></option>
                <option value="PRIVATE">Private</option>
                <option value="PARTNER">Partners only</option>
                <option value="PUBLIC">Public (incl. Partners)</option>
              </select>
            </div>
          </div>
        </div>
        <br />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div></div>
          <div>

          </div>
        </div>
      </form>
      <hr />
      <p>
        <strong>What happens next?</strong>
      </p>
      <p>
        Your Candidate will be shared with the Role Relay network based on the
        Audience you have selected. Only the anonymous details you have provided
        will be shared with other agencies.
      </p>
    </>
  );
};

const BullhornAction = () => {
  const { action } = useParams();

  return (
    <PageContainer  className="">
      {action === "candidate" && renderCandidate()}
    </PageContainer>
  );
};

export default BullhornAction;
